/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentPrizeTier } from './TournamentPrizeTier';
import {
    TournamentPrizeTierFromJSON,
    TournamentPrizeTierFromJSONTyped,
    TournamentPrizeTierToJSON,
    TournamentPrizeTierToJSONTyped,
} from './TournamentPrizeTier';
import type { TournamentPrizeBreakdownItem } from './TournamentPrizeBreakdownItem';
import {
    TournamentPrizeBreakdownItemFromJSON,
    TournamentPrizeBreakdownItemFromJSONTyped,
    TournamentPrizeBreakdownItemToJSON,
    TournamentPrizeBreakdownItemToJSONTyped,
} from './TournamentPrizeBreakdownItem';
import type { TournamentPrizeCalculation } from './TournamentPrizeCalculation';
import {
    TournamentPrizeCalculationFromJSON,
    TournamentPrizeCalculationFromJSONTyped,
    TournamentPrizeCalculationToJSON,
    TournamentPrizeCalculationToJSONTyped,
} from './TournamentPrizeCalculation';

/**
 * 
 * @export
 * @interface TournamentPrizePoolInput
 */
export interface TournamentPrizePoolInput {
    /**
     * 
     * @type {TournamentPrizeCalculation}
     * @memberof TournamentPrizePoolInput
     */
    type?: TournamentPrizeCalculation;
    /**
     * 
     * @type {number}
     * @memberof TournamentPrizePoolInput
     */
    fixedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentPrizePoolInput
     */
    percentageOfEntries?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentPrizePoolInput
     */
    sponsorContribution?: number;
    /**
     * Total prize pool amount — the canonical field the handler stores on the model.
     * @type {number}
     * @memberof TournamentPrizePoolInput
     */
    total?: number;
    /**
     * Guaranteed minimum prize pool in USD dollars. Devour tops the pool up to this figure when entry fees fall short and pays nothing when they cover it — the pool is never less than this, and never this PLUS entry fees. Requires a payoutTableId. Converted to Fuel at distribution time using the Fuel price at payout.
     * @type {number}
     * @memberof TournamentPrizePoolInput
     */
    guaranteedPoolUsd?: number;
    /**
     * Rank rewards granted by finishing position. Independent of the payout table.
     * @type {Array<TournamentPrizeTier>}
     * @memberof TournamentPrizePoolInput
     */
    tiers?: Array<TournamentPrizeTier>;
    /**
     * 
     * @type {Array<TournamentPrizeBreakdownItem>}
     * @memberof TournamentPrizePoolInput
     */
    breakdown?: Array<TournamentPrizeBreakdownItem>;
}



/**
 * Check if a given object implements the TournamentPrizePoolInput interface.
 */
export function instanceOfTournamentPrizePoolInput(value: object): value is TournamentPrizePoolInput {
    return true;
}

export function TournamentPrizePoolInputFromJSON(json: any): TournamentPrizePoolInput {
    return TournamentPrizePoolInputFromJSONTyped(json, false);
}

export function TournamentPrizePoolInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentPrizePoolInput {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : TournamentPrizeCalculationFromJSON(json['type']),
        'fixedAmount': json['fixedAmount'] == null ? undefined : json['fixedAmount'],
        'percentageOfEntries': json['percentageOfEntries'] == null ? undefined : json['percentageOfEntries'],
        'sponsorContribution': json['sponsorContribution'] == null ? undefined : json['sponsorContribution'],
        'total': json['total'] == null ? undefined : json['total'],
        'guaranteedPoolUsd': json['guaranteedPoolUsd'] == null ? undefined : json['guaranteedPoolUsd'],
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(TournamentPrizeTierFromJSON)),
        'breakdown': json['breakdown'] == null ? undefined : ((json['breakdown'] as Array<any>).map(TournamentPrizeBreakdownItemFromJSON)),
    };
}

export function TournamentPrizePoolInputToJSON(json: any): TournamentPrizePoolInput {
    return TournamentPrizePoolInputToJSONTyped(json, false);
}

export function TournamentPrizePoolInputToJSONTyped(value?: TournamentPrizePoolInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': TournamentPrizeCalculationToJSON(value['type']),
        'fixedAmount': value['fixedAmount'],
        'percentageOfEntries': value['percentageOfEntries'],
        'sponsorContribution': value['sponsorContribution'],
        'total': value['total'],
        'guaranteedPoolUsd': value['guaranteedPoolUsd'],
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(TournamentPrizeTierToJSON)),
        'breakdown': value['breakdown'] == null ? undefined : ((value['breakdown'] as Array<any>).map(TournamentPrizeBreakdownItemToJSON)),
    };
}

